// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Axios = require("axios");
let Config = require("../../config").default;
let ReasonPromise = require("../ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Stdlib_Result = require("@rescript/runtime/lib/js/Stdlib_Result.js");
let Utils__Promise = require("../../utils/Utils__Promise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

let config = Config;

let apiPath = config.apiPath;

let instance = Axios.create({
  withCredentials: true
});

function roleFromJs(x) {
  switch (x) {
    case "agent" :
      return "agent";
    case "client" :
      return "client";
    default:
      return;
  }
}

function parse(impersonated, js) {
  let role = roleFromJs(js.role);
  if (role !== undefined) {
    return {
      TAG: "Ok",
      _0: {
        id: js.id,
        role: role,
        email: js.email,
        impersonated: impersonated
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: {
        NAME: "INCOMPLETE_DATA",
        VAL: "unknown role: " + (js.role + " in login response")
      }
    };
  }
}

let UserInfo = {
  roleFromJs: roleFromJs,
  parse: parse
};

function login(email, password, rememberMe) {
  let postData_username = email.trim();
  let postData = {
    username: postData_username,
    password: password,
    rememberMe: rememberMe
  };
  return ReasonPromise.map(Utils__Promise.fromJsPromise(instance.post("/api/login", postData)), x => {
    if (x.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: "INVALID_EMAIL_PASSWORD"
      };
    }
    let data = x._0.data;
    if (data == null) {
      return {
        TAG: "Error",
        _0: {
          NAME: "INCOMPLETE_DATA",
          VAL: "was none"
        }
      };
    }
    let impersonated = Stdlib_Option.getOr(Primitive_option.fromNullable(data.impersonated), false);
    return Stdlib_Result.map(parse(impersonated, data.user), userInfo => ({
      accessToken: data.accessToken,
      expiresIn: data.expiresIn,
      user: userInfo,
      impersonated: Stdlib_Option.getOr(Primitive_option.fromNullable(data.impersonated), false)
    }));
  });
}

exports.config = config;
exports.apiPath = apiPath;
exports.instance = instance;
exports.UserInfo = UserInfo;
exports.login = login;
/* config Not a pure module */
